export function buildAgeString({ year, month, day }) {
  let yearStr = year > -1 ? `${year}岁` : "";
  let monthStr = month > -1 ? `${month}月` : "";
  let dayStr = day > -1 ? `${day}天` : "";
  if (year >= Number(process.env.VUE_APP_NO_AGE_DAY_DISPLAY_THRESHOLD)) {
    dayStr = "";
  }
  return yearStr + monthStr + dayStr;
}
